import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { UrlModal } from '../url.model';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import { FormsModule } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class DoctorsService {
  // URL = 'http://206.189.132.38:3005';
  URL = 'https://dev.api.doqmatokens.com';
  //URL = "http://localhost:3005";

  constructor(private httpClient: HttpClient) {}
deleteholi(token, holidayId){
return this.httpClient
.post<holidayData>(UrlModal._URL +'/doc/deleteholidays',holidayId,
{
  headers: new HttpHeaders({
    authorization: 'Bearer ' + token
  })
}
)
.pipe(
// map(res => {
//   return res.data.map(sinRes => {
//     return {
//       ...sinRes,
     
//     };
//   });
// })
);
}
  getHolidays(token, id) {
    return this.httpClient
      .post<holidayData>(
        UrlModal._URL + '/doc/getholidays',
        {
          clinicId: id,
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe(
        map((res) => {
          return res.data.map((sinRes) => {
            return {
              ...sinRes,
              startDate: moment(sinRes.startDate).format('ll'),
              endDate: moment(sinRes.endDate).format('ll'), // Sep 3, 2020
            };
          });
        })
      );
  }
  Refrence(data:any,token:string){
    return this.httpClient.post(UrlModal._URL + '/ref/addhosRef',
    data,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    });
  }

  getdocled(id, token) {
    return this.httpClient.post(UrlModal._URL + "/led/getLed", 
    {
      clinicId:id
    },{
      headers: new HttpHeaders({
        authorization: "Bearer " + token
      })
    });
  }

  updateLed(data, token) {
    return this.httpClient.post(UrlModal._URL + "/led/updateLed/" + data.id, data,{
      headers: new HttpHeaders({
        authorization: "Bearer " + token
      })
    });
  }


  addMember(data ,token) {
    return this.httpClient.post(UrlModal._URL + "/member" ,  data,{
      headers: new HttpHeaders({
        authorization: "Bearer " + token
      })
    });
  }


  editMember(data, token,id){     
    return this.httpClient.put(UrlModal._URL + "/member/" + id, data,{
      headers:new HttpHeaders({
        authorization: "Bearer" + token
      })
    });
  }

  deletMember(id ,token) {
    return this.httpClient.delete(UrlModal._URL + "/member/" +  id,{
      headers: new HttpHeaders({
        authorization: "Bearer " + token
      })
    });
  }

  getMember(clinicId,token) {
    return this.httpClient.get(UrlModal._URL + "/member/allMembers/"+clinicId ,  {
      headers: new HttpHeaders({
        authorization: "Bearer " + token
      })
    });
  }

  GetRefrence(id:any,token:string){
    return this.httpClient.post(UrlModal._URL + '/ref/gethosRef',
    {hospitalId:id},   
    {
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }

  DeletRefrence(id:any,token:string){
    return this.httpClient.post(UrlModal._URL + '/ref/deletRef',
    {refrenceId:id},   
    {
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }

  EditRefrence(data:any,token:string){
    return this.httpClient.post(UrlModal._URL + '/ref/editref',
    data,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }

  onDeleteClinic(clinicId, doctorId, token) {
    return this.httpClient
      .post(
        UrlModal._URL + '/doc/deleteclinic',
        { clinicId: clinicId, doctorId: doctorId },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe((res) => {
        return res;
      });
  }
  BookReceptionist(data:any,token:string){
    return this.httpClient.post(UrlModal._URL + '/ap/receptBookAppointment',
    data,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }

  printRecipt(data:any,token:string){
    return this.httpClient.post(UrlModal._URL + '/doc/getReceipt',
    data,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      })
    })
  }
  // addreceptionist( clinicId:any
  //   ,name: string,
  //   email: string,
  //   phoneNo: number){
  //     return this.httpClient.post(
  //       UrlModal._URL + 'ap/addreceptionist',
  //       {
  //         clinicId:clinicId,
  //         name: name,
  //         email: email,
  //         phoneNo: phoneNo,
  //       },
  //       {
  //         headers: new HttpHeaders({}),
  //       };
  //   }
  
  addreceptionist(
    data:any,
    token:string
  ) {
    return this.httpClient.post(
      UrlModal._URL + '/doc/addreceptionist',
      data,
      {
        headers: new HttpHeaders({
          authorization: 'Bearer ' + token,
        }),
      }
    );
  }

  editTest(
    data:any,
    token:string
  ) {
    return this.httpClient.put(
      UrlModal._URL + '/tests/test-in-clinic',
      data,
      {
        headers: new HttpHeaders({
          authorization: 'Bearer ' + token,
        }),
      }
    );
  }
  
  onDeleterecept(clinicId,recep_id,token) {
    return this.httpClient
      .post(
        UrlModal._URL + '/doc/deletereceptionist',
        { clinicId: clinicId,
          recep_id:recep_id
         },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
  }

  getTest(token, id) {
    return this.httpClient
      .get(
        UrlModal._URL + '/tests/test-in-clinic/' + id,
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
  }

  deletTest(data,token) {
    return this.httpClient
      .post(
        UrlModal._URL + '/tests/deleteTest' ,data,
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
  }

  getreceptionist(token, id) {
    return this.httpClient
      .post(
        UrlModal._URL + '/doc/getreceptionist',
        {
          clinicId: id,
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
  }

  changeClinicStaus(clinicId, startClinic, token) {
    return this.httpClient
      .post(
        UrlModal._URL + '/doc/startclinic',
        startClinic,
        // { clinicId: clinicId, startClinic: startClinic },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe((res) => {
        return res;
      });
  }

  saveHol(token, holidays, clinicId, doctorId) {
    const data = { ...holidays, clinicId: clinicId, doctorId: doctorId };
    return this.httpClient
      .post<DocDashData>(UrlModal._URL + '/doc/saveholidays', data, {
        headers: new HttpHeaders({
          authorization: 'Bearer ' + token,
        }),
      })
      .pipe((res) => {
        return res;
      });
  }

  getSingleDoctorFromDb(id: string, token: string) {
    return this.httpClient
      .get<singleDoctorData>(UrlModal._URL + '/doc/doctor/' + id)
      .pipe(
        map((res) => {
          if (res.status === 200) {
            return res.data;
          }
        })
      );
  }
  getSinglereceptionist(id: string, token: string) {
    return this.httpClient
      .get(UrlModal._URL + '/doc/doctor/' + id + '?receptionist=true')
      .pipe(
        map((res:any) => {
          if (res.status === 200) {
            return res.data;
          }
        })
      );
  }
  savePatientLimit(id, limit, token) {
    this.httpClient
      .post(
        UrlModal._URL + '/doc/patientlimit',
        {
          patientLimit: limit,
          doctorId: id,
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .subscribe((res) => {});
  }
  savePatientNumber(id, patNum, token) {
    return this.httpClient
      .post(
        UrlModal._URL + '/doc/patientnumber',
        {
          patientNumber: patNum,
          doctorId: id,
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  getClinicDetails(id, token) {
    return this.httpClient
      .get<clinicTimingData>(UrlModal._URL + '/doc/clinic/' + id)
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  setDoctorStatus(docId, isEnabled: boolean, token) {
    return this.httpClient
      .post(
        UrlModal._URL + '/doc/updatedocstatus',
        {
          doctorId: docId,
          isEnabled: isEnabled,
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  saveDoctorToDatabase(
    name: string,
    email: string,
    password: string,

    phoneNo: number
  ) {
    return this.httpClient.post(
      UrlModal._URL + '/doc/regdoc',
      {
        name: name,
        email: email,
        password: password,
        phoneNo: phoneNo,
      },
      {
        headers: new HttpHeaders({}),
      }
    );
  }

  getDocType(token) {
    return this.httpClient
      .get<DocType>(UrlModal._URL + '/doc/getdoctype', {
        headers: new HttpHeaders({
          authorization: 'Bearer ' + token,
        }),
      })
      .pipe(
        map((res) => {
          return res.data;
        })
      );
  }
  getMemberCouncil() {
    return this.httpClient
      .get<MemberCouncil>(UrlModal._URL + '/cn/getcouncil', {
        headers: new HttpHeaders({}),
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  getCouncilCountry() {
    return this.httpClient
      .get<MemberCouncilCON>(UrlModal._URL + '/cn/getcouncilcountries', {
        headers: new HttpHeaders({}),
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  getCouncilByCountry(country) {
    return this.httpClient
      .get<MemberCouncil>(UrlModal._URL + '/cn/getsinglecouncil/' + country, {
        headers: new HttpHeaders({}),
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  AddnewClinic(clinicData, token) {
    return this.httpClient
      .post(UrlModal._URL + '/doc/addnewclinic', clinicData, {
        headers: new HttpHeaders({
          authorization: 'Bearer ' + token,
        }),
      })
      .pipe(map((res) => {}));
  }

  getAllClinic(id, token) {
    return this.httpClient.post<AllclinicData>(
      UrlModal._URL + '/doc/getallclinic',
      {
        doctorId: id,
      },
      {
        headers: new HttpHeaders({
          authorization: 'Bearer ' + token,
        }),
      }
    );
  }

  updateDoctorToDatabase(
    name: string,
    doctorType: string,
    email: string,
    experience: number,
    degree: string,

    line1: string,
    city: string,
    pincode: number,
    state: string,

    clinic: string,
    token: string,
    id: string,
    consultationFee,
    district
  ) {
    return this.httpClient.put(
      UrlModal._URL + '/doc/updatedoctor',
      {
        name: name,
        doctorType: doctorType,
        email: email,
        experience: experience,
        degree: degree,

        line1: line1,
        city: city,

        pincode: pincode,

        state: state,
        district: district,
        clinic: clinic,
        firstVisitFee: consultationFee,
      },
      {
        headers: new HttpHeaders({
          authorization: 'Bearer ' + token,
        }),
      }
    );
  }

  updateDoctorServiceToDatabase(service, id: string, token) {
    return this.httpClient.put(
      UrlModal._URL + '/doc/updatedoctor',
      {
        docServices: service,
      },
      {
        headers: new HttpHeaders({
          authorization: 'Bearer ' + token,
        }),
      }
    );
  }

  updateprofileImage(token, Id, selectedfile) {
    var fm = new FormData();
    fm.append('id', Id);
    fm.append('doctorDp', selectedfile);
    return this.httpClient.post(UrlModal._URL + '/doc/saveprofileimage', fm, {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + token,
      }),
    });
  }
  delImage(token, id, index) {
    let pl = {
      id: id,
      index: index,
    };
    return this.httpClient.post(UrlModal._URL + '/doc/deleteclinicphotos', pl, {
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    });
  }
  updateClinicPhotos(token, Id, selectedfile) {
    var fm = new FormData();
    fm.append('id', Id);
    fm.append('clinicImage', selectedfile);
    return this.httpClient.post(UrlModal._URL + '/doc/updateclinicphotos', fm, {
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    });
  }

  onDelete(id, token) {
    return this.httpClient.get(UrlModal._URL + '/doc/deletedoctor/' + id, {
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    });
  }

  setClinicTiming(startTime, endTime, id, token) {
    return this.httpClient
      .post(
        UrlModal._URL + '/doc/clinictiming',
        {
          startTime: startTime,
          endTime: endTime,
          doctorId: id,
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe((res) => {
        return res;
      });
  }
  setClinicData(
    weekdays,
    patientLimit,
    id,
    startTime,
    endTime,
    clinicName,
    district,
    line1,
    city,
    pincode,
    state,
    token
  ) {
    return this.httpClient
      .post<updatedClinic>(
        UrlModal._URL + '/doc/updateclinicdata',
        {
          weekDays: weekdays,
          patientLimit: patientLimit,
          id: id,
          startTime: startTime,
          endTime: endTime,
          district: district,
          line1: line1,
          city: city,
          pincode: pincode,
          state: state,
          clinicName: clinicName,
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe((res) => {
        return res;
      });
  }
  setdocDashData(doctorId, token, clinicId) {
    console.log(clinicId);
    return this.httpClient
      .post<DocDashData>(
        UrlModal._URL + '/ap/getappcount',
        {
          doctorId: doctorId,
          clinicId: clinicId,
        },
        {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + token,
          }),
        }
      )
      .pipe((res) => {
        return res;
      });
  }
  //docdashdata

  verifyPhn() {
    return this.httpClient
      .post(UrlModal._URL + '/phn/phonenumverify', {})
      .pipe();
  }
  getCityDoctor(city,count,page:number){
    return this.httpClient.get(UrlModal._URL +'/doc/getfilterDocCity/'+city+'?page='+page+'&limit='+count);
  }
  doctorFilter(name,limit,page:number){
    return this.httpClient.get(UrlModal._URL +'/doc/getfilterdocname/'+name+'?page='+page+'&limit='+limit);
  }
  viewDoctor(id){
    return this.httpClient.get(UrlModal._URL + '/doc/doctor/'+id)
  }
  updateApptNum(data,token){
    return this.httpClient.post(UrlModal._URL +"/ap/updateApptNum",data,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }
  getHospitals(page:any){
    return this.httpClient.get(UrlModal._URL + '/hos/gethospitals?page='+page+'&limit=4')
  }
  changeSlot(payload:any,token:String){
    return this.httpClient.post(UrlModal._URL+'/doc/changeSlot',payload,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }
  saveAppointmentTransaction(data,token){
    return this.httpClient.post(UrlModal._URL+'/ap/appt-transaction',data,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }
  getAppointmentTransaction(id,token){
    return this.httpClient.get(UrlModal._URL+'/ap/appt-transaction/'+id,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }
  getAppontmentDetail(clinicId,appointmentDate,token,slot=1){
    return this.httpClient.post(UrlModal._URL+"/ap/getAppontmentDetailArray",{clinicId,appointmentDate,slot},{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }
  bookApptMultipleDays(data,token){
    return this.httpClient.post(UrlModal._URL+"/ap/bookApptMultipleDays",data,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }
  getmemberAmountByDateRange(data,token){
    return this.httpClient.post(UrlModal._URL+"/member/getmemberAmountByDateRange",data,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }
  getReceiptForNormal(data,token){
    return this.httpClient.post(UrlModal._URL+"/doc/getReceiptForNormal",data,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }
  getMembersByName(clinicId,name,token){
    return this.httpClient.get(UrlModal._URL+"/member/getMembersByName/"+clinicId+"/"+name,{
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    })
  }
}

export interface singleDoctorData {
  status: number;
  message: string;
  data: {
    _id: string;
    name: string;
    doctorType: {
      isDeleted: boolean;
      _id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
      __v: number;
    };
    email: string;
    experience: number;
    password: string;
    consultationFee: { firstVisit: Number };
    mcId: string;
    membership: string;
    degree: string[];
    address: {
      line1: string;
      city: string;
      pincode: number;
      district: string;
      state: string;
    };
    clinic: string;
    profileStatus: {
      profile: boolean;
      dailyLimit: boolean;
      scheduling: boolean;
    };
    services: string[];
    isPhoneVerified: boolean;
    isVerified: boolean;
    profileImage: string;
    phoneNo: number;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
}

/*{"status":200,"message":"getting the clinics data",
"clinics":[{"patientLimit":60,"patientNumber":0,"weekDays":["Wednesday"],"clinicImages":[],"clinicImagesThumbnail":[],"appointmentNumber":0
,"isEmergencySlotOpened":false,"emergencyPatientLimit":0,"isDeleted":false,"isEnabled":false,"_id":"5f2d4646e753024c092b5599","doctorId":"5f2d4645f2e2ae1540d93494","__v":0,"createdAt":"2020-08-07T12:17:10.007Z","updatedAt":"2020-08-08T14:59:54.180Z"},{"timming":{"startTime":"19:55","endTime":"21:57"},"address":{"line1":"powdergali goregaoneast filmcity","city":"mumbai","district":"mumbai","pincode":4444444,"state":"NL"},"patientLimit":45,"patientNumber":0,"weekDays":["Sunday","Monday","Wednesday","Thursday","Friday","Tuesday"],"clinicImages":[],"clinicImagesThumbnail":[],"appointmentNumber":0,"isEmergencySlotOpened":false,"emergencyPatientLimit":0,"isDeleted":false,"isEnabled":false,"_id":"5f3e6bf05d93a4288c015b95","doctorId":"5f2d4645f2e2ae1540d93494","clinicName":"rima","createdAt":"2020-08-20T12:26:24.945Z","updatedAt":"2020-08-20T12:26:24.945Z","__v":0},{"timming":{"startTime":"16:44","endTime":"18:19"},"address":{"line1":"powdergali goregaoneast filmcity","city":"mumbai","district":"mumbai","pincode":4444444,"state":"NL"},"patientLimit":44,"patientNumber":0,"weekDays":["Monday","Tuesday","Wednesday","Thursday"],"clinicImages":[],"clinicImagesThumbnail":[],"appointmentNumber":0,"isEmergencySlotOpened":false,"emergencyPatientLimit":0,"isDeleted":false,"isEnabled":false,"_id":"5f3e70285d93a4288c015b9d","doctorId":"5f2d4645f2e2ae1540d93494","clinicName":"rima","createdAt":"2020-08-20T12:44:24.573Z","updatedAt":"2020-08-20T12:44:24.573Z","__v":0},{"timming":{"startTime":"16:44","endTime":"18:19"},"address":{"line1":"powdergali goregaoneast filmcity","city":"mumbai","district":"mumbai","pincode":4444444,"state":"ML"},"patientLimit":44,"patientNumber":0,"weekDays":["Monday","Tuesday","Wednesday","Thursday"],"clinicImages":[],"clinicImagesThumbnail":[],"appointmentNumber":0,"isEmergencySlotOpened":false,"emergencyPatientLimit":0,"isDeleted":false,"isEnabled":false,"_id":"5f3e70445d93a4288c015b9e","doctorId":"5f2d4645f2e2ae1540d93494","clinicName":"rima","createdAt":"2020-08-20T12:44:52.670Z","updatedAt":"2020-08-20T12:44:52.670Z","__v":0},{"timming":{"startTime":"18:27","endTime":"19:23"},"address":{"line1":"powdergali goregaoneast filmcity","city":"mumbai","district":"mumbai","pincode":4444444,"state":"OD"},"patientLimit":56,"patientNumber":0,"weekDays":["Sunday","Monday","Tuesday"],"clinicImages":[],"clinicImagesThumbnail":[],"appointmentNumber":0,"isEmergencySlotOpened":false,"emergencyPatientLimit":0,"isDeleted":false,"isEnabled":false,"_id":"5f3e72155d93a4288c015b9f","doctorId":"
5f2d4645f2e2ae1540d93494","clinicName":"rima","createdAt":"2020-08-20T12:52:37.220Z","updatedAt":"2020-08-20T12:52:37.220Z","__v":0}]}*/

export interface AllclinicData {
  status: number;
  message: string;
  clinics: [
    {
      clinicName: string;
      patientLimit: number;
      weekDays: string[];
      clinicImages: [];
      patientNumber: number;
      address: {
        line1: string;
        city: string;
        pincode: number;
        district: string;
        state: string;
      };

      emergencyPatientLimit: Number;
      appointmentNumber: number;
      isEmergencySlotOpened: boolean;
      isDeleted: boolean;
      isEnabled: boolean;
      _id: string;

      timming: {
        startTime: String;
        endTime: String;
      };
      doctorId: string;
      __v: Number;
      createdAt: string;
      updatedAt: string;
    }
  ];
}

export interface clinicTimingData {
  status: number;
  message: string;
  data: {
    patientLimit: number;

    patientNumber: number;
    appointmentNumber: number;
    isDeleted: boolean;
    isEnabled: boolean;
    _id: string;
    timming: {
      startTime: String;
      endTime: String;
    };
    doctorId: string;
    __v: Number;
    createdAt: string;
    updatedAt: string;
  };
}
export interface updatedClinic {
  status: number;
  message: string;
  updatedClinic: {
    patientLimit: number;
    patientNumber: number;
    appointmentNumber: number;
    isDeleted: boolean;
    isEnabled: boolean;
    timming: {
      startTime: String;
      endTime: String;
    };

    address: {
      line1: string;
      city: string;
      pincode: number;
      district: string;
      state: string;
    };
    _id: string;
    doctorId: string;
    __v: Number;
    createdAt: string;
    updatedAt: string;
  };
}
export interface DocType {
  status: string;
  message: string;
  data: [
    {
      _id: string;
      isDeleted: boolean;
      name: string;
      slug: string;
      doctorCategory: string;
      createdAt: string;
      updatedAt: string;
      __v: number;
    }
  ];
}
export interface MemberCouncil {
  status: string;
  message: string;
  council: {
    _id: string;
    isDeleted: boolean;
    councilName: [];
    country: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
}

export interface MemberCouncilCON {
  status: string;
  message: string;
  council: [
    {
      _id: string;
      country: string;
      createdAt: string;
      updatedAt: string;
      __v: number;
    }
  ];
}
export interface DocDashData {
  status: number;
  message: string;
  data: {
    doc: {
      consultationFee: { firstVisit: number };
      _id: string;

      clinicId: {
        patientLimit: number;

        _id: string;
      };
    };
    appData: number;
  };
}
export interface holidayData {
  status: number;
  message: string;
  data: [
    {
      isDeleted: boolean;
      isEnabled: boolean;
      _id: string;
      clinicId: { _id: string; clinicName: string };
      doctorId: string;
      __v: number;
      createdAt: string;
      endDate: string;
      startDate: string;
      updatedAt: string;
    }
  ];
}
/*{"status":200,"message":"List of holidays","data":{"isDeleted":false,
"isEnabled":true,"_id":"5f50b8ea742b4d3ede50e778","clinicId":{"_id":"5f4ce8e2742b4d3ede4ef3f2",
"clinicName":"HealthCure"},"doctorId":"5f4ce8e272d22907bab83393","__v":0,"createdAt":"2020-09-03T09:35:38.338Z",
"endDate":"2020-09-03T18:30:00.000Z","startDate":"2020-09-02T18:30:00.000Z","updatedAt":"2020-09-03T09:35:38.338Z"}}*/
